export default "__VITE_ASSET__D7k91AVF__"